const FontResize = function(opts){
    var el = opts.el ? opts.el : '';
    var max = opts.max ? opts.max : 749;
    var min = opts.min ? opts.min : 180;
    var fSize = 0;
    var minFont = opts.minFont ? opts.minFont : 6;
    var maxFont = opts.maxFont ? opts.maxFont : 40;

    var initPage = function(){
        var bdWidth = el.clientWidth ? el.clientWidth : el.offsetWidth;

        if(bdWidth <= min){
            fSize = minFont;
        }else if(bdWidth >=max){
            fSize = maxFont;
        }else{
            fSize = minFont + (bdWidth - min) / ((max - min) / (maxFont - minFont));
        }

        el.style.fontSize = fSize + 'px';
    };

    initPage();

    if(window.onresize){
        window.onresize = null;
    }

    window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    var count = 0;
    window.onresize = function(e){
        // initPage();
        window.requestAnimationFrame(initPage);
    }
}

export default FontResize;



// WEBPACK FOOTER //
// ./src/assets/js/font-resize.js